var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "directory-company-detail" },
    [
      _vm.showUpdateInfo
        ? _c("div", { staticClass: "last-update" }, [
            _c("div", { staticClass: "last-update__text" }, [
              _vm._v("\n      " + _vm._s(_vm.updateInfo) + "\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("CompanyInfo", {
        staticClass: "main-comp",
        attrs: {
          detail: _vm.company,
          index: _vm.index,
          id: "main-comp" + _vm.index,
          showIndex: false,
          withDropdown: false,
          resetValidation: _vm._resetValidation,
          category: ["companies"],
          type: _vm.type,
          canCompInfoEditable: _vm.canCompInfoEditableForEngineer,
          title: _vm.$t("directory.label.level1"),
        },
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.subCompLength
        ? _c(
            "div",
            { staticClass: "sub-company" },
            [
              _vm._l(_vm.company.subCompanies, function (subComp, subIndex) {
                return [
                  _c("CompanyInfo", {
                    key: subIndex,
                    attrs: {
                      detail: subComp,
                      index: subIndex,
                      lengthOfArray: _vm.company.subCompanies.length,
                      resetValidation: _vm._resetValidation,
                      category: ["companies", _vm.index, "subCompanies"],
                      type: _vm.type,
                      id: _vm.index + "-sub-Comp-" + subIndex,
                      isSub: true,
                      title: _vm.$t("directory.label.level2"),
                      withDropdown: _vm.canCompInfoEditableForEngineer,
                      canCompInfoEditable: _vm.canCompInfoEditableForEngineer,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { key: subIndex, staticClass: "comp-detail" },
                    [
                      _vm._l(
                        subComp.subDetails,
                        function (subDetail, detailIndex) {
                          return [
                            _c("CompanyInfo", {
                              key: detailIndex,
                              attrs: {
                                detail: subDetail,
                                index: detailIndex,
                                lengthOfArray: subComp.subDetails.length,
                                isDetail: true,
                                resetValidation: _vm._resetValidation,
                                category: [
                                  "companies",
                                  _vm.index,
                                  "subCompanies",
                                  subIndex,
                                  "subDetails",
                                ],
                                id:
                                  _vm.index +
                                  "-sub-Comp-" +
                                  subIndex +
                                  "-sub-detail-" +
                                  detailIndex,
                                type: _vm.type,
                                title: _vm.$t("directory.label.level3"),
                                withDropdown:
                                  _vm.canCompInfoEditableForEngineer,
                                canCompInfoEditable:
                                  _vm.canCompInfoEditableForEngineer,
                              },
                            }),
                          ]
                        }
                      ),
                      _vm._v(" "),
                      _vm.canCompInfoEditable
                        ? _c("div", { key: subIndex, staticClass: "buttons" }, [
                            _c(
                              "a",
                              {
                                staticClass: "add-comp",
                                on: {
                                  click: function ($event) {
                                    return _vm.addCompanyDetail(
                                      subComp,
                                      subIndex
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("action.addCompDetail")))]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.subCompLength > 0
                    ? _c("hr", { key: subIndex, staticClass: "indent" })
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canCompInfoEditable
        ? _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--round btn--grey",
                attrs: { type: "button" },
                on: { click: _vm.addSubComp },
              },
              [_vm._v(_vm._s(_vm.$t("action.addSubComp")))]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }